import { render, staticRenderFns } from "./editStaff.vue?vue&type=template&id=50ffa83e&scoped=true"
import script from "./editStaff.vue?vue&type=script&lang=js"
export * from "./editStaff.vue?vue&type=script&lang=js"
import style0 from "./editStaff.vue?vue&type=style&index=0&id=50ffa83e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ffa83e",
  null
  
)

export default component.exports